import { useState, useEffect } from 'react';
import API from '../../../api/API';
import TokenService from '../../../api/tokenService';
import { transformSquadreData, initializePlayerStats } from '../../match/utils/matchUtils';

export const useRefertoData = (searchParams, refertoForm, refertoAPI) => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isEditMode, setIsEditMode] = useState(false);
  const [partitaCorrente, setPartitaCorrente] = useState(null);
  const [hasLoadedOnce, setHasLoadedOnce] = useState(false);

  const loadData = async () => {
    setLoading(true);
    setError(null);
    
    try {
      const s1 = searchParams.get('s1');
      const s2 = searchParams.get('s2');
      const nome = searchParams.get('nome');

      if (!s1 || !s2) {
        throw new Error('Parametri mancanti: s1 e s2 sono obbligatori');
      }

      // Load match data using partite.hash API
      const matchData = await API.partite.hash(s1, s2, nome);

      if (!matchData || !matchData.data) {
        throw new Error('Impossibile caricare i dati della partita');
      }

      const data = matchData.data;

      // Create team objects from the match data
      const squadraA = {
        id: data.s1,
        nome: data.s1Nome,
        giocatori: data.statistiche
          .filter(stat => stat.idS === data.s1)
          .map(stat => ({
            id: stat.idP,
            idG: stat.idG,
            nome: '', // Nome not included in API response
            cognome: '', // Cognome not included in API response
            maglia: '', // Maglia not included in API response
            ...initializePlayerStats(stat)
          }))
      };

      console.log(squadraA)

      const squadraB = {
        id: data.s2,
        nome: data.s2Nome,
        giocatori: data.statistiche
          .filter(stat => stat.idS === data.s2)
          .map(stat => ({
            id: stat.idP,
            idG: stat.idG,
            nome: '', // Nome not included in API response
            cognome: '', // Cognome not included in API response
            maglia: '', // Maglia not included in API response
            ...initializePlayerStats(stat)
          }))
      };

      if (!squadraA || !squadraB) {
        throw new Error('Squadre non trovate nei dati ricevuti');
      }

      // Set teams in form
      refertoForm.setSquadraA(squadraA);
      refertoForm.setSquadraB(squadraB);

      // Set initialized player arrays
      refertoForm.setGiocatoriSquadraA(squadraA.giocatori);
      refertoForm.setGiocatoriSquadraB(squadraB.giocatori);

      // Check if match already exists (id > 0 means existing match)
      if (data.id && data.id > 0) {
        // Match exists, enter edit mode and load existing statistics
        setIsEditMode(true);
        setPartitaCorrente({
          id: data.id,
          squadra1: data.s1,
          squadra2: data.s2,
          tipo: data.tipo || 'girone',
          fascia: data.fascia || 'prima',
          torneo: data.torneo || data.idE, // Include edition info from match data
          nome: nome || data.nome || null
        });

        // Convert existing match statistics to referto format
        refertoAPI.convertMatchToRefertoFormat(
          data, 
          refertoForm.setRefertoData, 
          squadraA, 
          squadraB
        );
      } else {
        // New match
        setIsEditMode(false);
        setPartitaCorrente({
          id: null,
          squadra1: data.s1,
          squadra2: data.s2,
          tipo: 'girone',
          fascia: 'prima',
          torneo: data.torneo || data.idE, // Include edition info from match data
          nome: nome || null
        });
      }

    } catch (err) {
      console.error('Error loading referto data:', err);
      setError(err.message || 'Errore nel caricamento dei dati');
    } finally {
      setLoading(false);
      setHasLoadedOnce(true); // Mark as loaded to prevent future calls
    }
  };

  useEffect(() => {
    const s1 = searchParams.get('s1');
    const s2 = searchParams.get('s2');
    
    // Only load if we have the required parameters and haven't loaded yet
    if (s1 && s2 && !hasLoadedOnce) {
      loadData();
    }
  }, [searchParams.get('s1'), searchParams.get('s2'), hasLoadedOnce]);

  const resetAndReload = () => {
    setHasLoadedOnce(false);
    setError(null);
    loadData();
  };

  return {
    loading,
    error,
    isEditMode,
    partitaCorrente,
    setIsEditMode,
    setPartitaCorrente,
    loadData,
    resetAndReload
  };
};